export function fmtNum(n) {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString();
}

export function positionColor(pos) {
  switch (pos) {
    case "QB": return "bg-[#0A0A0A] text-white";
    case "RB": return "bg-white text-[#0A0A0A] border border-[#0A0A0A]";
    case "WR": return "bg-[#F3F4F6] text-[#0A0A0A] border border-[#0A0A0A]";
    case "TE": return "bg-[#E5E7EB] text-[#0A0A0A] border border-[#0A0A0A]";
    case "PICK": return "bg-[#FACC15] text-[#0A0A0A] border border-[#0A0A0A]";
    default: return "bg-white text-[#0A0A0A] border border-[#0A0A0A]";
  }
}

export function trendColor(t) {
  if (!t) return "text-[#52525B]";
  if (t > 0) return "text-[#00C853]";
  if (t < 0) return "text-[#FF3B30]";
  return "text-[#52525B]";
}
